<template>
<div>
<div
v-if="!hideVendorSpinner"
class="spinner-border"
style="margin:auto;display:block;margin-top:60px"
></div>
<div v-else>
<div :class="'form-group row ' + initialColSize" v-if="isMultiSelect == 'false'">
<label v-show="label" for="tags" :class="isExtraCol + ' col-form-label'">{{label}}</label>
<div :class="customPosition" v-if="!dataLoading" style="padding-left:14px">
<!-- <select
class="form-control"
v-model="modalValue"
v-bind:disabled="nonEditable ? true : false"
@change="setSelected()"
id="my-select"
>
<option :value="0">{{selection}}</option>
<option
v-for="item in dropdownList"
:key="( isVendor ? item.id : ( isProduct ? item.asin : item.id ) )"
:value="( isVendor ? item.id : ( isProduct ? item.asin : item.id ) )"
>{{ (isProduct ? item.product_title : item.name) }}</option>
</select>-->
	<multiselect
		v-model="modalValue"
		class="form-control multi-dropdown select_filter"
		v-bind:disabled="nonEditable ? true : false"
		:placeholder="selection"
		label="name"
		deselectLabel=""
		selectedLabel=""
		selectLabel=""
		@search-change="fetchDynamicList()"
		@input="setSelected()"
		:options="dropdownList? dropdownList:[]"
		track-by="id"
		ref="multiselect"
		:multiple="false"
		:taggable="false"
	>
		<template slot="noResult">
			<div>Oops! No elements found</div>
		</template>
	</multiselect>
</div>
<div class="col-sm-1" v-if="dataLoading">
<div class="spinner-border" role="status">
<span class="sr-only"></span>
</div>
</div>
</div>
<div v-else>
<div class="col-sm-1 offset-sm-2" v-if="dataLoading">
<div class="spinner-border" role="status">
<span class="sr-only"></span>
</div>
</div>

</div>
</div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
	name: "ReusableComponent",
	components: { Multiselect },
	data() {
	return {
		list: [],
		modalValue: null,
		productList: [],
		isNewselected: false,
		hideVendorSpinner: true,

	};
	},
	computed: {},
	props: {
		isCalledFrom:String,
		isVendor: Boolean,
		label: String,
		selection: String,
		isbrand: Boolean,
		isProduct: Boolean,
		fromProduct: String,
		isMultiSelect: String,
		productVal: Array,
		nonEditable: Boolean,
		dataLoading: Boolean,
		dropdownList: Array,
		selectedValue: String,
		selectedList: Array,
		customPosition:{
		type:String,
		default:'col-sm-5',
		required: false
		},
		initialColSize:		{
			type: String,
			default: 'col-sm-12',
			required: false
		},
		isExtraCol:{
		type: String,
		default: 'col-sm-2',
		required: false
	}
},
	mounted() {
	// this.dropdownList = this.selectedValue
	// ? { name: this.selectedValue,id:this.selectedValue }
	// : this.selectedList;
		this.modalValue = this.selectedValue && this.dropdownList ? this.getSelectedObject(this.selectedValue,this.dropdownList) : null;

	},
		watch:{
		selectedValue(){
		this.modalValue = this.selectedValue && this.dropdownList ? this.getSelectedObject(this.selectedValue,this.dropdownList) : null;
		}
	},
	methods: {
		getSelectedObject(id,list){
			var obj;
			for(var i=0;i<list.length;i++){
				if(id == list[i].id){
					obj = list[i];
					break;
				}
			}
			return obj;
		},
		setSelected() {
			if (this.isCalledFrom == "formInput") {
				this.$emit("selectInputValue",this.modalValue ? this.modalValue.id : null,this.selection)
			}
			else if(this.isCalledFrom == "header"){
				this.$emit("selectedHeaderValue",this.modalValue ? this.modalValue.id : null,this.selection)
			}
			else if(this.isCalledFrom == "all"){
				this.$emit("selectInputValue",this.modalValue ? this.modalValue : null,this.selection)

			}
			else{
				this.$emit("showNextView",this.modalValue ? this.modalValue.id : null);
				if (this.isProduct) {
					this.productList.push(this.modalVthis.productList ? this.productList : null);
				}
			}
		},
		fetchDynamicList(){
			var search = this.$refs.multiselect.search ? this.$refs.multiselect.search :"";
			this.$emit("fetchDynamicList",search,this.selection)
		},
		setSelectedProduct(data) {
		// if (data.length) {
		// this.list = data.map(res => {
		// return res.asin;
		// });
			this.$emit("showNextView", data);
		//	}
		}
	}
};
</script>

<style lang="scss">
</style>
